import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider, Global } from "@mantine/core";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={{
      primaryColor: "saffron",
      colors: {
        saffron: [
          "#fff4e6",
          "#ffe0b3",
          "#ffc966",
          "#ffb347",
          "#ffa64d",
          "#FF9933", // main
          "#e6822b",
          "#cc6f1f",
          "#a35316",
          "#7a3d0f",
        ],
      },
    }}
  >
    {/* Set global styles including body background */}
    <Global
      styles={{
        body: {
          backgroundColor: "#ffffff", // Light gray background (change as you like)
        },
      }}
    />

    <Provider store={store}>
      <App />
    </Provider>
  </MantineProvider>
);
